import { useMutation } from '@tanstack/react-query';

import { fetchOptionWayUrl } from './api';

export const useGetOptionWayUrl = () => {
    return useMutation({
        mutationFn: fetchOptionWayUrl,
        onSuccess: (data) => {
            window.open(data.url, '_blank', 'noopener,noreferrer');
        },
    });
};
